import Crud from '../views/MedicalAgreement/Crud'
import Entity from '../views/MedicalAgreement/Add'

let routes = {
    path: '/medical-agreements',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/medical-agreements/add',
            name: 'NewMedicalAgreement',
            component: Entity,
            meta: {
                pageTitle: 'Convênios',
                breadcrumb: [
                    {
                        text: 'Adicionar Convênio',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/medical-agreements/edit/:id?',
            name: 'EditMedicalAgreement',
            component: Entity,
            meta: {
                pageTitle: 'Convênios',
                breadcrumb: [
                    {
                        text: 'Editar Convênio',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/medical-agreements',
            name: 'list-medical-agreements',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Convênios',
                breadcrumb: [
                    {
                        text: 'Convênios',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
